var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342.44,
    height: 38.384,
    viewBox: "0 0 342.44 38.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guidelines",
    transform: "translate(-1407.87 -2154.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(1407.87 2154.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 1.507,
    height: 33.45,
    transform: "translate(80.495 4.458)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_577",
    transform: "translate(0 0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474",
    transform: "translate(0.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    d: "M53.083,1.4H46.641l-.14.42-.56,2.8-.14.42-.28,1.541V7l-.28.84L45.1,8.4h4.621A3.608,3.608,0,0,0,52.8,5.881h0L53.22,4.2V3.92l.42-1.961.14-.56Z",
    transform: "translate(15.679 -1.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    d: "M48.8,7.3H46.98L41.1,35.169h1.961a5.22,5.22,0,0,0,4.9-4.062L53,7.3Z",
    transform: "translate(14.077 0.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    d: "M21.026,30.629l7.142-15.265-4.2,19.886H29.71l4.9-22.967A4.526,4.526,0,0,0,34.05,8.5a4.03,4.03,0,0,0-3.5-1.4,6.818,6.818,0,0,0-1.681.14,5.648,5.648,0,0,0-4.2,3.5L17.385,25.728l-.14-14.985a3.348,3.348,0,0,0-2.8-3.5A5.744,5.744,0,0,0,12.9,7.1,6.777,6.777,0,0,0,8.842,8.5,7.047,7.047,0,0,0,6.6,12.284L1.7,35.251H7.442l4.2-19.886.56,14.844.14,1.961c0,.42.14.98.14,1.4a2.865,2.865,0,0,0,2.941,2.381,4.279,4.279,0,0,0,3.781-2.1l.14-.14a9.419,9.419,0,0,0,.98-1.541Z",
    transform: "translate(-1.7 0.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    d: "M25.087,30.549a4.764,4.764,0,0,0,.14,1.4,2.923,2.923,0,0,0,1.541,2.241,7.457,7.457,0,0,0,4.2.98H37.83a6.961,6.961,0,0,0,6.3-3.362,9.305,9.305,0,0,0,1.26-3.781L47.21,19.2H40.492l-.7,3.081h.7l-1.121,5.461v.14c-.28.84-.98,1.26-2.241,1.26H32.369a1.18,1.18,0,0,1-.98-.98v-.14L34.33,14.443a1.507,1.507,0,0,1,1.4-1.12H46.794L48.054,7.3H36.711a8.728,8.728,0,0,0-5.6,1.541,9.655,9.655,0,0,0-2.661,5.322s-3.081,14.706-3.221,15.266a3.48,3.48,0,0,0-.142,1.12Z",
    transform: "translate(7.683 0.961)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1451",
    d: "M1.1,14.4",
    transform: "translate(-1.1 3.806)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Approve",
    d: "M12.474-23.1H3.465V0h3.3V-7h5.709c6.006,0,9.636-3.036,9.636-8.052S18.48-23.1,12.474-23.1Zm-.1,13.233H6.765V-20.229h5.61c4.224,0,6.435,1.881,6.435,5.181S16.6-9.867,12.375-9.867ZM26.631,0h9.735C43.791,0,48.84-4.686,48.84-11.55S43.791-23.1,36.366-23.1H26.631Zm3.3-2.871V-20.229h6.237c5.709,0,9.372,3.5,9.372,8.679s-3.663,8.679-9.372,8.679Zm39.93-17.358V-23.1h-16.3V0h3.3V-9.339H68.442v-2.838H56.859v-8.052ZM98.736-4.158a9.776,9.776,0,0,1-5.412,1.485c-5.313,0-9.174-3.8-9.174-8.877,0-5.148,3.861-8.877,9.207-8.877a9.158,9.158,0,0,1,6.7,2.673L102.1-19.8a11.579,11.579,0,0,0-8.877-3.564c-7.161,0-12.375,4.983-12.375,11.814S86.064.264,93.159.264A13.652,13.652,0,0,0,101.9-2.673v-9.009H98.736ZM120.549-17.49v9.042c0,3.762-2.112,5.808-5.412,5.808-3,0-4.719-1.716-4.719-5.148v-9.7H107.25V-7.425c0,5.148,3,7.623,7.524,7.623a7.116,7.116,0,0,0,5.94-2.838V0h3V-17.49Zm10.461-3.366a2.073,2.073,0,0,0,2.145-2.112,2.053,2.053,0,0,0-2.145-2.013,2.086,2.086,0,0,0-2.145,2.079A2.059,2.059,0,0,0,131.01-20.856ZM129.426,0h3.168V-17.49h-3.168Zm22.209-24.486v9.636a7.442,7.442,0,0,0-6.105-2.805,8.489,8.489,0,0,0-8.844,8.91A8.516,8.516,0,0,0,145.53.2a7.389,7.389,0,0,0,6.237-2.97V0H154.8V-24.486ZM145.794-2.574a5.791,5.791,0,0,1-5.907-6.171,5.764,5.764,0,0,1,5.907-6.138,5.756,5.756,0,0,1,5.874,6.138C151.668-5.016,149.127-2.574,145.794-2.574Zm30.492-6.072c0-5.379-3.6-9.009-8.646-9.009a8.566,8.566,0,0,0-8.778,8.91c0,5.214,3.762,8.943,9.4,8.943a8.779,8.779,0,0,0,6.9-2.838l-1.749-2.046a6.53,6.53,0,0,1-5.049,2.112c-3.465,0-5.94-2.046-6.336-5.115h14.19C176.253-7.986,176.286-8.382,176.286-8.646Zm-8.646-6.336a5.454,5.454,0,0,1,5.61,5.016H162.03A5.452,5.452,0,0,1,167.64-14.982ZM180.345,0h3.168V-24.486h-3.168Zm10.461-20.856a2.073,2.073,0,0,0,2.145-2.112,2.053,2.053,0,0,0-2.145-2.013,2.086,2.086,0,0,0-2.145,2.079A2.059,2.059,0,0,0,190.806-20.856ZM189.222,0h3.168V-17.49h-3.168Zm18.216-17.655a7.5,7.5,0,0,0-6.3,2.805v-2.64H198.1V0h3.168V-9.009c0-3.8,2.178-5.808,5.544-5.808,3,0,4.719,1.683,4.719,5.115V0H214.7V-10.065C214.7-15.213,211.695-17.655,207.438-17.655Zm28.71,9.009c0-5.379-3.6-9.009-8.646-9.009a8.566,8.566,0,0,0-8.778,8.91c0,5.214,3.762,8.943,9.4,8.943a8.779,8.779,0,0,0,6.9-2.838l-1.749-2.046a6.53,6.53,0,0,1-5.049,2.112c-3.465,0-5.94-2.046-6.336-5.115h14.19C236.115-7.986,236.148-8.382,236.148-8.646ZM227.5-14.982a5.454,5.454,0,0,1,5.61,5.016h-11.22A5.452,5.452,0,0,1,227.5-14.982ZM245.223.2c4.653,0,7.557-2.013,7.557-5.181,0-6.8-11.088-3.432-11.088-7.557,0-1.386,1.353-2.409,4.125-2.409a9.134,9.134,0,0,1,5.049,1.386l1.353-2.508a12.727,12.727,0,0,0-6.369-1.584c-4.488,0-7.293,2.112-7.293,5.247,0,6.963,11.055,3.564,11.055,7.491,0,1.485-1.221,2.376-4.158,2.376a11.239,11.239,0,0,1-6.138-1.815L238-1.848A12.623,12.623,0,0,0,245.223.2Z",
    transform: "translate(89.66 33)",
    fill: "#fff",
    opacity: 0.796
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/guidelines.3e7d5d48e5f3e06a6c10b4ee82414b70.svg";
export { ForwardRef as ReactComponent };